import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect, Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, delay, exhaustMap, map, tap, switchMap } from 'rxjs/operators';
import {
  LoginErrorAction,
  LoginSuccessAction,
  LoginTypes, LogoutSuccessAction,
  LogoutTypes,
  UserActionTypes,
  GetCurrentUserSuccessAction
} from '../../actions/user/user.actions';
import { Action } from '@ngrx/store/src/models';
import { UserService } from '../../services/user/user.service';
import { User } from 'src/app/shared/models/user/User';
import { TicketService } from '../../services/ticket/ticket.service';

@Injectable()
export class LoginEffects {
  @Effect()
  public login(): Observable<Action> {
    return this.actions.pipe(
      ofType(LoginTypes.LOGIN),
      delay(500),
      exhaustMap((action: any) =>
        this.userService
          .signin(action.username, action.password, action.keepSignedIn)
          .pipe(
            map(user => LoginSuccessAction({ authenticated: !!user, user })),
            catchError(error => of(LoginErrorAction({ error })))
          )
      )
    );
  }

  @Effect()
  public logout: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(LogoutTypes.LOGOUT),
      tap(action => {
        return this.userService.signOut();
      }),
      map(() => LogoutSuccessAction())
    )
  );

  @Effect()
  public getCurrentUser: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(UserActionTypes.GET_CURRENT_USER),
      switchMap(
        () => of(this.userService.getCurrentUser())
      ),
      map((user: User) => {
        return GetCurrentUserSuccessAction({ user });
      })
    )
  );

  constructor(
    private actions: Actions,
    private userService: UserService,
    private ticketService: TicketService,
  ) { }
}
